import { WalletState, initialState as walletState } from './wallet/state';

export default interface RootState {
    wallet: WalletState;
}

export const initialState: RootState = {
    wallet: walletState,
}